import { render } from "./ks-welcome.vue?vue&type=template&id=e90ce43c"
import script from "./ks-welcome.vue?vue&type=script&lang=js"
export * from "./ks-welcome.vue?vue&type=script&lang=js"

import "./ks-welcome.vue?vue&type=style&index=0&id=e90ce43c&lang=css"
script.render = render

export default script